import { Box, Flex, Text } from '@chakra-ui/react'
import { ArrowBack } from '@components/icons'
import { useAudioCapture, useWidget } from '@hooks'
import React from 'react'
import { MicrophoneSelector } from './select-mic'

export const AudioSettings = ({
  setShowSettings
}: {
  setShowSettings: (showSettings: boolean) => void
}) => {
  const { settings } = useWidget()
  const { startContentShare } = useAudioCapture()
  return (
    <Flex flexDirection="column" gap="small">
      <Flex alignItems="center" justifyContent="space-between">
        <Box
          _hover={{ cursor: 'pointer' }}
          onClick={() => setShowSettings(false)}
        >
          <ArrowBack fill="black" width={16} height={16} />
        </Box>
        <Text>Audio Settings</Text>
        <Box visibility="hidden" width="16px" height="16px" />
      </Flex>
      <MicrophoneSelector />
      <Text
        textDecoration="underline"
        color={settings?.minifiedViewSettings?.audioIndicatorColor ?? 'primary'}
        _hover={{ cursor: 'pointer' }}
        onClick={startContentShare}
      >
        Share browser audio
      </Text>
    </Flex>
  )
}
